import { createSlice } from '@reduxjs/toolkit';
import { AvsConfiguration, AvsUpdateConfigPayload } from '../avs.types';
import {
  getAvsConfigurations,
  updateAvsConfigurations,
  requestServiceAccess,
} from './avsConfiguration.actions';

export interface AvsConfigurationState {
  configurations: AvsConfiguration[];
  updatedConfigurations: AvsUpdateConfigPayload[];
  isFetchingConfigurations: boolean;
  isSubmitting: boolean;
  error: string;
}

const initialState: AvsConfigurationState = {
  configurations: [],
  updatedConfigurations: [],
  isFetchingConfigurations: false,
  isSubmitting: false,
  error: '',
};

const avsConfigurationSlice = createSlice({
  name: 'avsConfiguration',
  initialState,
  reducers: {
    setUpdateConfigurations: (state, { payload }) => {
      state.updatedConfigurations = payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(getAvsConfigurations.pending, state => {
      state.isFetchingConfigurations = true;
    });
    builder.addCase(getAvsConfigurations.fulfilled, (state, { payload }) => {
      state.isFetchingConfigurations = false;
      state.configurations = payload.map((configuration: AvsConfiguration) => ({
        ...configuration,
        id: configuration.bank_code,
        isSelectable: false,
      }));
    });
    builder.addCase(getAvsConfigurations.rejected, state => {
      state.isFetchingConfigurations = false;
      state.error = 'Failed to load Account Verification configurations';
    });

    builder.addCase(updateAvsConfigurations.pending, state => {
      state.isSubmitting = true;
    });
    builder.addCase(updateAvsConfigurations.fulfilled, state => {
      state.isSubmitting = false;
      state.updatedConfigurations = [];
    });
    builder.addCase(updateAvsConfigurations.rejected, state => {
      state.isSubmitting = false;
    });

    builder.addCase(requestServiceAccess.pending, state => {
      state.isSubmitting = true;
    });
    builder.addCase(requestServiceAccess.fulfilled, state => {
      state.isSubmitting = false;
    });
    builder.addCase(requestServiceAccess.rejected, state => {
      state.isSubmitting = false;
      state.error = 'Failed to request service access';
    });
  },
});

export default avsConfigurationSlice.reducer;
export const { setUpdateConfigurations } = avsConfigurationSlice.actions;
